import React, { Component } from "react";
import "./App.css";
import firebase from "firebase";
import Header from "./components/Header";
import GoogleAds from "./GoogleAds";
import TotalVotes from "./components/TotalVotes";
import BudgetVote from "./components/BudgetVote";
import Comment from "./components/Comment";
import Footer from "./components/Footer";
import FooterCredits from "./components/FooterCredits";

var firebaseConfig = {
  apiKey: "AIzaSyB0tATlNzZYEIK7iAyrHoQISwXsWPerBFw",
  authDomain: "budget-voting-poll.firebaseapp.com",
  databaseURL: "https://budget-voting-poll.firebaseio.com",
  projectId: "budget-voting-poll",
  storageBucket: "budget-voting-poll.appspot.com",
  messagingSenderId: "696737071712",
  appId: "1:696737071712:web:e457051c27bebc3edc3905"
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const increment = firebase.firestore.FieldValue.increment(1);
const collection = "budget2020";

const CardsIcon01 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_01.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon02 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_02.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon04 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_04.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon05 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_05.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon06 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_06.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon07 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_07.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon08 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_08.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon09 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_09.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon10 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_10.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon11 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_11.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon12 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_12.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon13 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_13.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon14 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_14.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon15 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_15.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon16 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_16.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};

const voteQuest = [
  {
    id: "budget-2020-card-01",
    title: "Minimum wage hike in major cities",
    descr: "Beginning 2020, the minimum wage will be increased from RM1,100 to RM1,200 per month in major cities.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon01 />
  },
  {
    id: "budget-2020-card-02",
    title: "Increase in maternity leave",
    descr: "Maternity leave will be increased from 60 to 90 days, starting in 2021. ",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon02 />
  },
  {
    id: "budget-2020-card-04",
    title: "Lower minimum price for foreigners to own property",
    descr: "Foreigners can now purchase urban high-rise properties for at least RM600,000, instead of RM1 million.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon04 />
  },
  {
    id: "budget-2020-card-05",
    title: "Higher taxes for those earning RM2m or more a year",
    descr: "Those earning more than RM2 million per annum have to pay 2 percent more tax than the 28 percent tax being charged now.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon05 />
  },
  {
    id: "budget-2020-card-06",
    title: "Tax for digital services such as Netflix, Spotify",
    descr: "Next year's Digital Services Tax will begin on Jan 1, 2020. ",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon06 />
  },
  {
    id: "budget-2020-card-07",
    title: "Incentive for unemployed graduates who get jobs",
    descr: "Unemployed graduates who find work, along with their employers will receive RM500 and RM300 per month respectively for 2 years.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon07 />
  },
  {
    id: "budget-2020-card-08",
    title: "Tax break to develop digital economy",
    descr: "Income tax exemption up to 10 years for electrical and electronics companies investing in selected knowledge-based services.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon08 />
  },
  {
    id: "budget-2020-card-09",
    title: "Lower toll rates on PLUS-managed roads",
    descr: "Gov't says tolled roads managed by PLUS will be 18 percent cheaper on average, though implementation date has yet to be announced.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon09 />
  },
  {
    id: "budget-2020-card-10",
    title: "Subsidised vaccine for kids",
    descr: "RM60 million to be allocated to subsidise kids' pneumococcal vaccines, which currently cost about RM325 a dose at private clinics and require two doses.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon10 />
  },
  {
    id: "budget-2020-card-11",
    title: "Resolving S'pore causeway gridlock",
    descr: "Malaysian government will spend RM85 million to upgrade Customs, Immigration and Quarantine (CIQ) Complex as well as resolve traffic congestion along Johor-Singapore Causeway.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon11 />
  },
  {
    id: "budget-2020-card-12",
    title: "Attracting China investment",
    descr: "‘Special Channel’ to attract investments from China will be set up under InvestKL, in order to bring them on par with US investments.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon12 />
  },
  {
    id: "budget-2020-card-13",
    title: "RON95 fuel subsidy includes non-BSH holders too",
    descr: "New fuel card allows all, including those who aren't on Bantuan Sara Hidup (BSH) welfare payments, to buy 100 litres of RON95 subsidised fuel if they fulfill conditions. ",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon13 />
  },
  {
    id: "budget-2020-card-14",
    title: "No increase in welfare aid, though categories expanded",
    descr: "BSH payment amounts remain the same, although expanded to include disabled and single people above 40 who earn under RM2,000 a month.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon14 />
  },
  {
    id: "budget-2020-card-15",
    title: "E-sports funds doubled",
    descr: "Funding for e-sports has been increased to RM20 million in wake of industry's 'growing potential'.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon15 />
  },
  {
    id: "budget-2020-card-16",
    title: "Less special draws for number betting",
    descr: "The number of special draws for Number Forecast Operator (NFO) will be reduced from 11 to 8 times a year.",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon16 />
  }
];

class App extends Component {
  constructor() {
    super();
    this.state = {
      voteCards: [],
      isLoading: true,
      isUserVoted: null,
      totalActionCount: 0,
      totalAverageLikesCount: 0,
      totalAverageDislikesCount: 0
    };
  }

  componentDidMount = async () => {
    (function() {
      let d = document,
        s = d.createElement("script");
      s.src = "https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-55378495366fd469";
      (d.head || d.body).appendChild(s);
    })();

    const clonedQuest = [...voteQuest];

    const newVoteQuest = clonedQuest.map(item => {
      const getLock = localStorage.getItem(`${item.id}-lock`);
      console.log(getLock);
      let isVoted = getLock === "1";
      console.log(isVoted);
      item.isVoted = isVoted;
      return item;
    });

    const allVotesDataPromise = [];

    newVoteQuest.map(item => {
      const newFetch = db
        .collection("budget2020")
        .doc(item.id)
        .get();
      allVotesDataPromise.push(newFetch);
      return null;
    });

    const allVotesDataSnapshots = await Promise.all(allVotesDataPromise);

    const allVotesData = {};
    newVoteQuest.map((item, index) => {
      allVotesData[item.id] = allVotesDataSnapshots[index].data();
      return null;
    });

    const finalVoteQuest = newVoteQuest.map(item => {
      const voteData = allVotesData[item.id];
      item.likes = voteData.likes || 0;
      item.dislikes = voteData.dislikes || 0;
      return item;
    });

    console.log(finalVoteQuest);

    this.setState({ voteCards: newVoteQuest, isLoading: false }, () => {
      this.calculateAllActions();
    });
  };

  calculateAllActions = () => {
    const { voteCards } = this.state;
    let actionCount = 0;
    let averageLikesCount = 0;
    let averageDislikesCount = 0;
    voteCards.map(item => {
      const { likes, dislikes } = item;
      const totalItemCount = likes + dislikes;
      actionCount = actionCount + totalItemCount;
      averageLikesCount = parseInt((likes / totalItemCount) * 100);
      averageDislikesCount = parseInt((dislikes / totalItemCount) * 100 + 1);
      return null;
    });

    this.setState({ totalActionCount: actionCount });
    this.setState({ totalAverageLikesCount: averageLikesCount });
    this.setState({ totalAverageDislikesCount: averageDislikesCount });
  };

  updateCurrentCounts = async () => {
    const clonedQuest = [...voteQuest];
    const allVotesDataPromise = [];

    clonedQuest.map(item => {
      const newFetch = db
        .collection("budget2020")
        .doc(item.id)
        .get();
      allVotesDataPromise.push(newFetch);
      return null;
    });

    const allVotesDataSnapshots = await Promise.all(allVotesDataPromise);

    const newClone = clonedQuest.map((item, index) => {
      const countForThisItem = allVotesDataSnapshots[index].data();
      item.likes = countForThisItem.likes;
      item.dislikes = countForThisItem.dislikes;
      return item;
    });

    this.setState({ voteQuest: newClone });
  };

  lockUser = itemId => {
    localStorage.setItem(`${itemId}-lock`, "1");
  };

  updateUserIsVoted = itemId => {
    const clonedVoteCards = [...this.state.voteCards];
    console.log(clonedVoteCards);
    const newVoteCards = clonedVoteCards.map(item => {
      if (item.id === itemId) {
        item.isVoted = true;
      }
      return item;
    });
    this.setState({ voteCards: newVoteCards }, () => {
      this.calculateAllActions();
    });
  };

  handleLikeEvent = async itemId => {
    try {
      await db
        .collection(collection)
        .doc(itemId)
        .update({ likes: increment });
      this.lockUser(itemId);
      this.updateUserIsVoted(itemId);
      this.updateCurrentCounts();
      console.log("DONE!");
    } catch (error) {
      console.log(error);
    }
  };

  handleDislikeEvent = async itemId => {
    try {
      await db
        .collection(collection)
        .doc(itemId)
        .update({ dislikes: increment });
      this.lockUser(itemId);
      this.updateUserIsVoted(itemId);
      this.updateCurrentCounts();
      console.log("DONE!");
    } catch (error) {
      console.log(error);
    }
  };

  handleEvent = voteCardId => {
    const updatedVoteQuest = this.state.voteCards.map(voteCards => {
      if (voteCards.id === voteCardId) {
        return Object.assign({}, voteCards, {
          votes: voteCards.votes + 1
        });
      } else {
        return voteCards;
      }
    });

    this.setState({
      members: updatedVoteQuest
    });
  };

  render() {
    return (
      <>
        <Header />
        <section className="uk-section uk-padding-remove-top">
          <div className="uk-container uk-container-small">
            <TotalVotes totalActionCount={this.state.totalActionCount} totalAverageLikesCount={this.state.totalAverageLikesCount} totalAverageDislikesCount={this.state.totalAverageDislikesCount} />
            <ul className="uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-text-center uk-grid-match uk-grid" uk-height-match="target: > li > .uk-card > .uk-card-body">
              {!this.state.isLoading &&
                this.state.voteCards.map(voteCard => (
                  <BudgetVote
                    key={voteCard.id}
                    id={voteCard.id}
                    title={voteCard.title}
                    descr={voteCard.descr}
                    likes={voteCard.likes}
                    dislikes={voteCard.dislikes}
                    onVoteLike={this.handleLikeEvent}
                    onVoteDislike={this.handleDislikeEvent}
                    isUserVoted={voteCard.isVoted}
                    icon={voteCard.icon}
                  />
                ))}
            </ul>
          </div>
          <div className="uk-container uk-flex uk-flex-center uk-margin-large uk-light">
            <div>
              <p className="uk-text-small uk-text-uppercase uk-margin-small" style={{ fontSize: "10px", letterSpacing: "2px" }}>
                Advertisement
              </p>
              <div id="ad-slot"></div>
            </div>
            <GoogleAds />
          </div>
        </section>
        <Comment />
        <Footer />
        <FooterCredits />
      </>
    );
  }
}

export default App;
